module.exports = __webpack_public_path__ + "img/r5.f2846bee.jpg";